export const cardLoyaltyProgramExternal = {
    targetClientId: 'C02345N6',
};
